import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { AppConfig } from '../../../config/app';
import styles from './styles/login';

/* AccountActivated Component */
class AccountActivated extends React.Component {
  state = {
  }
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */

  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  /* Render Page */
  render() {
    const { classes } = this.props;
    return (
      <div>
        <main className={classes.main}>
          <CssBaseline />
          <Paper className={classes.paper}>
            <Avatar className={classes.avatar}>
              <img alt='edSeed Logo ' src={AppConfig.base+'/logo.png?v1'} style={{ width: '95%' }} />
            </Avatar>
            <Typography variant="body" style={{ width: '100%',textAlign:'center' }}>
              {this.props.match.params.invalidReason?this.props.match.params.invalidReason:'Account Activated Successfully'}
              
            </Typography>
            <Typography component={Link} to='/' style={{ width: '100%',textAlign:'center' }}>
                Go to home
            </Typography>
          </Paper>

        </main>

      </div>

    );
  }
}

AccountActivated.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(AccountActivated));